import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';


class Tab extends React.Component {

  reference = React.createRef();

  onClick = () => {
    const { active, onClick, adjustUnderline } = this.props;

    if (!active) {
      onClick();
      adjustUnderline();
    }
  };

  render() {
    const { reference, onClick } = this;
    const { id, children, active, customClasses } = this.props;
    const { customClass, customActiveClass } = customClasses;

    const classes = classNames({
      [customClass]: true,
      [customActiveClass]: active
    });

    return (
      // eslint-disable-next-line jsx-a11y/role-supports-aria-props
      <button type="button"
              className={ classes }
              data-test={ `button-tab-${id}` }
              aria-selected={ active }
              ref={ reference }
              onClick={ onClick }
      >
        {children}
      </button>
    );
  }
}

Tab.propTypes = {
  active: PropTypes.bool,
  customClasses: PropTypes.shape({
    customClass: PropTypes.string,
    customActiveClass: PropTypes.string
  }),
  onClick: PropTypes.func,
  adjustUnderline: PropTypes.func,
  children: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired
};

Tab.defaultProps = {
  onClick: () => {},
  adjustUnderline: () => {},
  active: false,
  customClasses: {
    customClass: '',
    customActiveClass: ''
  }
};

export default Tab;
